WiseMetering.Model.ZoneReportType = WiseMetering.Model.extend({
    urlRoot: '/report_types/zone_report_types',

    getDescription: function(type) {
        let reportDescription = i18next.t('zone_report_types.description');

        if (type === 'SiteUtilityReport') {
            reportDescription += i18next.t('zone_report_types.utility_kind_report');
        } else if (type === 'SiteEventsReport') {
            reportDescription += i18next.t('zone_report_types.events_report');
        } else if (type === 'SiteFolderReport') {
            reportDescription += i18next.t('zone_report_types.folder_report');
        } else if (type === 'SiteMarkersReport') {
            reportDescription += i18next.t('zone_report_types.markers_report');
        } else if (type === 'SiteMeteringSchemaReport') {
            reportDescription += i18next.t('zone_report_types.metering_schema_report');
        } else if (type === 'SiteDetailedReport') {
            reportDescription += i18next.t('zone_report_types.detailed_report');
        } else if (type === 'SiteSurveyReport') {
            reportDescription += i18next.t('zone_report_types.survey_report');
        } else if (type === 'SiteSchemaReport') {
            reportDescription += i18next.t('zone_report_types.schema_report');
        }

        return reportDescription;
    }
});
